import { render } from "./AddPlanModal.vue?vue&type=template&id=0ce53770&scoped=true&ts=true"
import script from "./AddPlanModal.vue?vue&type=script&lang=ts"
export * from "./AddPlanModal.vue?vue&type=script&lang=ts"

import "./AddPlanModal.vue?vue&type=style&index=0&id=0ce53770&scoped=true&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce53770"]])

export default __exports__